module.exports = __webpack_public_path__ + "fonts/MonsieurLaDoulaise-Regular.c8403ed2.ttf";